import { c as _c } from "react/compiler-runtime";
import { cn } from '@/utils/tailwindcss-override';
import { Loader2 } from 'lucide-react';
import Link from 'next/link';
import React from 'react';
export const NavLink: React.FC<{
  href: string;
  icon: React.ElementType;
  label: string;
  isActive: boolean;
  /** the tab of the page that is shown, announced as the current page */
  isCurrent: boolean;
  color: string | undefined;
  onClick: (href: string) => void;
  isLoading: boolean;
  loadingHref: string | undefined;
}> = t0 => {
  const $ = _c(23);
  const {
    href,
    icon: Icon,
    label,
    isActive,
    isCurrent,
    color,
    onClick,
    isLoading,
    loadingHref
  } = t0;
  const isCurrentlyLoading = isLoading && loadingHref === href;
  let t1;
  if ($[0] !== href || $[1] !== onClick) {
    t1 = () => onClick(href);
    $[0] = href;
    $[1] = onClick;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isCurrent ? "page" : undefined;
  let t3;
  if ($[3] !== isActive) {
    t3 = cn("flex h-full flex-1 flex-col items-center justify-center space-y-1 py-2", {
      "text-blue-600": isActive
    });
    $[3] = isActive;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== Icon || $[6] !== color || $[7] !== isActive || $[8] !== isCurrentlyLoading) {
    t4 = <div className="relative">{isCurrentlyLoading ? <div className={cn("h-9 w-12 rounded-xl px-3 py-1.5", {
        "text-conveniat-green bg-green-200": isActive,
        "text-cevi-red": color === "red",
        "text-cevi-red bg-red-200": isActive && color === "red"
      })}><Loader2 className={cn("m-auto animate-spin", {
          "text-conveniat-green": true,
          "text-cevi-red": color === "red"
        })} /></div> : <Icon className={cn("h-9 w-12 rounded-xl px-3 py-1 text-gray-300", {
        "text-conveniat-green bg-green-200": isActive,
        "text-cevi-red": color === "red",
        "text-cevi-red bg-red-200": isActive && color === "red"
      })} />}</div>;
    $[5] = Icon;
    $[6] = color;
    $[7] = isActive;
    $[8] = isCurrentlyLoading;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = color === "red";
  let t6;
  if ($[10] !== isActive || $[11] !== t5) {
    t6 = cn("mt-1 text-xs font-semibold text-gray-400", {
      "text-conveniat-green font-bold": isActive,
      "text-cevi-red": t5
    });
    $[10] = isActive;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== label || $[14] !== t6) {
    t7 = <span className={t6}>{label}</span>;
    $[13] = label;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== href || $[17] !== t1 || $[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t7) {
    t8 = <Link href={href} prefetch={true} onClick={t1} aria-current={t2} className={t3}>{t4}{t7}</Link>;
    $[16] = href;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};